import defaultMock from '../../language_assessment/examMockConfig';

const examMockConfig = { ...defaultMock, title: 'ASSESS-595_TESTER', freeNavigation: false };

export default examMockConfig;
